<mat-label class="subHeading">Payment Term<span *ngIf="isRequired" class="star">*</span></mat-label>
<div formGroupName="payment_term" class="d-flex align-items-center mt-2" style="gap: 10px;">
    <input formControlName="from" [maxlength]="2" type="text" class="w-50 m-0" placeholder="From" appNumberOnly>
    -
    <input formControlName="to" [maxlength]="2" type="text" class="w-50 m-0" placeholder="To" appNumberOnly>
</div>